// Remove the following lines, if you do not need any of Bootstrap's JavaScript features
// import bootstrap from "bootstrap";
// import Parallax from 'parallax-js'
import $ from "jquery";
window.jQuery = $;
window.$ = $;
require ('jquery-parallax.js');
var Masonry = require('masonry-layout');
import mediumZoom from 'medium-zoom';
require('paroller.js');
import 'slick-carousel';
import DataTable from 'datatables.net-bs5';
// import WOW from'wowjs'
// const WOW = require('wowjs');


// import simpleParallax from 'simple-parallax-js';


const bootstrap = window.bootstrap = require('bootstrap');
// var parallax_images = document.getElementsByClassName('parallax');
// new simpleParallax( parallax_images,{
//     overflow: false
//     // scale: 1.05
//     // orientation: 'right'
// });

var stickyHeaderHeight = 200 ;

if(document.querySelector('.grid')){
    var msnry = new Masonry( '.grid', {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true
    });
}





function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

$(function() { 

    new DataTable('#jobs', {
        'responsive': true,
        'pageLength': 20,
        'language': {
            url: agencea.pluginsurl + '/agencea-jobs/public/js/dataTables.fr-FR.json'
        },
       // "order": [[ 4, "desc" ]],
        'columnDefs': [ {
            'targets': [-1], 
            'orderable': false, 
         }]
    });


    $('.slick-team').slick(
        {
            infinite: true,
            autoplay: false,
            autoplaySpeed: 5000,
            slidesToShow: 6,
            slidesToScroll : 3,
            arrows: true,
            responsive:[
                {
                    breakpoint: 992,
                    settings: {
                      slidesToShow: 4,
                      slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                }
            ]
       }
    );
    $('.slick-expo').slick(
        {
            infinite: true,
            autoplay: false,
            autoplaySpeed: 5000,
            slidesToShow: 4,
            slidesToScroll : 1,
            arrows: true,
            responsive:[
                {
                    breakpoint: 992,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                }
            ]
       }
    );

     /**
     * Anchor smooth scroll
     */
      $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .on('click', function(event) {
          // On-page links
          if (
              location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
              && 
              location.hostname == this.hostname
          ) {
              // Figure out element to scroll to
              var target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
              // Does a scroll target exist?
              if (target.length) {
                  // Only prevent default if animation is actually gonna happen
                  event.preventDefault();
                  document.documentElement.scrollTo({
                      top: target.offset().top - stickyHeaderHeight,
                      behavior: "smooth"
                  })
              }
          }
      });

    $('.accordion-collapse').on('shown.bs.collapse', function (e) {
        var $panel = $(this).closest('.accordion-item');
        document.documentElement.scrollTo({
            top: $panel.offset().top - stickyHeaderHeight,
            behavior: "smooth"
        });
    });

    //Clone burger icon to overlay menu
    $('.navbar-fixed-opened').on('show.bs.collapse', function () {
        $('.navbar-closer').remove();
        $('.navbar-fixed-opened').prepend(`<button class="navbar-toggler navbar-closer" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMain" aria-controls="navbarMain" aria-expanded="true" aria-label="Fermer">
        <i class="fa fa-lg fa-times"></i></button>`);
    }) ;

    // pas de dropdown en mobile sinon les niveaux 1 sont pas cliquabkes
    $('#navbarMain').on('show.bs.collapse', function () {
        $('#navbarMain').find('.dropdown-menu').addClass('show');
        $('#navbarMain').find('[data-bs-toggle="dropdown"]').removeClass('dropdown-toggle').removeAttr('data-bs-toggle').attr('aria-expanded', true);
    }) ;

    // Close menu & overlays when Escape
    $(document).on('keydown', function(e) {
        if (e.key == "Escape") {
            $('#navbarMain').collapse('hide');
            $('.agencea-overlay').removeClass('shown');
        }
    });

    //Wow
    if('function' === typeof WOW){
        new WOW().init();
    }
    

    // Sticky menu
    if (window.matchMedia("(min-width: 768px)").matches) {
        window.addEventListener('scroll', function() {
            if (window.scrollY > 160) {
                $('#navbar-main')
                    .addClass('fixed-top')
                    // .addClass('bg-dark')
                    // .removeClass('bg-transparent');
                let navbar_height = document.querySelector('.navbar').offsetHeight;
                document.body.style.paddingTop = navbar_height + 'px';
                $('.logo-sticky').removeClass('d-none') ;
            } else {
                $('#navbar-main')
                    .removeClass('fixed-top')
                    // .removeClass('bg-dark')
                    // .addClass('bg-transparent');
                document.body.style.paddingTop = '0';
                $('.logo-sticky').addClass('d-none') ;
            } 
        });
    }

    // $('.dropdown-toggle').dropdown();
    mediumZoom('[data-zoomable]');
    $("[data-paroller-factor]").wrap('<div class="paroller-wrap"></div>');
    $("[data-paroller-factor]").paroller();
    

    // jarallaxVideo();
    jarallax(document.querySelectorAll('.jarallax'), {
        speed: 0.2
    });

    // Menu
    $(".dropdown").hover(function(){
        var dropdownMenu = $(this).children(".dropdown-menu");
        if(dropdownMenu.is(":visible")){
            dropdownMenu.parent().toggleClass("open");
        }
    });


    $(document).on('click', '.navbar .dropdown-toggle', function(){
        if (window.matchMedia("(min-width: 992px)").matches) {
            window.location.href= $(this).attr('href');
        }
    });

    // Search form full screen [search_full_screen]
    $(document).on('click', '#search-full-screen__toggle', function(){
        $('#search-full-screen__target')
            .prepend(`<button class="navbar-toggler agencea-overlay__close" type="button" aria-controls="search-full-screen__form" aria-expanded="true" aria-label="Fermer">
        <i class="fa fa-lg fa-times"></i></button>`)
            .addClass('shown');
    });

    $(document).on('click', '.agencea-overlay__close', function(){
        $('.agencea-overlay')
            .removeClass('shown')
            .find('.agencea-overlay__close').remove();
           
    });
   



    // Counters
    $(window).on('scroll', function(){
        $('.count, .down_count').each(function () {
            if(isInViewport($(this)[0])){
                $(this).addClass('countAnimated');
            }
        });

        $('.count.countAnimated:not(.stopped)').each(function () {
                $(this).css('opacity', 1);
                $(this).prop('Counter',0).animate({
                    Counter: $(this).text()
                }, {
                    duration: 4000,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(Math.ceil(now));
                    }
                });
                $(this).addClass('stopped');
        });

        // Down Counters
        $('.down_count.countAnimated:not(.stopped)').each(function () {
                $(this).css('opacity', 1);
                $(this).prop('Counter',10).animate({
                    Counter: $(this).text()
                }, {
                    duration: 2000,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(Math.ceil(now));
                    }
                });
                $(this).addClass('stopped');
        });
    });
      


   //Scroll back to top
		
		var progressPath = document.querySelector('.progress-wrap path');
        if(progressPath){
            var pathLength = progressPath.getTotalLength();
            progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
            progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
            progressPath.style.strokeDashoffset = pathLength;
            progressPath.getBoundingClientRect();
            progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';		
            var updateProgress = function () {
                var scroll = $(window).scrollTop();
                var height = $(document).height() - $(window).height();
                var progress = pathLength - (scroll * pathLength / height);
                progressPath.style.strokeDashoffset = progress;
            }
            updateProgress();
            $(window).scroll(updateProgress);	
            var offset = 150;
            // var duration = 550;
            jQuery(window).on('scroll', function() {
                if (jQuery(this).scrollTop() > offset) {
                    jQuery('.progress-wrap').addClass('active-progress');
                } else {
                    jQuery('.progress-wrap').removeClass('active-progress');
                }
            });				
            jQuery('.progress-wrap').on('click', function(event) {
                event.preventDefault();
                document.documentElement.scrollTo({
                    top: 0,
                    behavior: "smooth"
                })
                return false;
            });
        }


    /**
     * Map partners
     */

    if($('#contact_map').length > 0){
    

        $.post(agencea.ajaxurl, {'action':'geocode_contact_address'}, function(response){
            if(response.lat_lng != ""){
                var contactmap = L.map('contact_map', { dragging: !L.Browser.mobile, tap: !L.Browser.mobile }).setView([response.lat_lng.lat, response.lat_lng.lng], 15);

                L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZmxpc3RlZmxpc3RlIiwiYSI6ImNpeGt2bnliczAwMjIycW4wMmkwMzI3c2UifQ.fYceJb6F_mtjN3fmXz0wMQ', {
                    maxZoom: 18,
                    // attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, ' +
                    //     'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
                    id: 'mapbox/streets-v11',
                    tileSize: 512,
                    zoomOffset: -1
                }).addTo(contactmap);
           
                var marker = L.marker([response.lat_lng.lat, response.lat_lng.lng], {title:'Pistes Solidaires'+'<br>'+response.address}).addTo(contactmap);
                marker.bindPopup('Pistes Solidaires'+'<br>'+response.address).openPopup();
                    
            }
        
        });

       

        // $('.partners-list > li').on('click', function(){
        //     var id = $(this).data('id') ;
        //     var _marker = partnersmap.getMarkerById(id);
        //     _marker.fire('click');
        // });
    }


    if($('#partners_map').length > 0){
        // Get marker by ID
        L.Map.include({
            getMarkerById: function (id) {
                var marker = null;
                this.eachLayer(function (layer) {
                    if (layer instanceof L.Marker) {
                        if (layer.options.id === id) {
                            marker = layer;
                        }
                    }
                });
                return marker;
            }
        });


        var partnersmap = L.map('partners_map', { dragging: !L.Browser.mobile, tap: !L.Browser.mobile }).setView([44.8947086,-0.2065675], 2);

        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZmxpc3RlZmxpc3RlIiwiYSI6ImNpeGt2bnliczAwMjIycW4wMmkwMzI3c2UifQ.fYceJb6F_mtjN3fmXz0wMQ', {
            maxZoom: 18,
            // attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, ' +
                // 'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            id: 'mapbox/streets-v11',
            tileSize: 512,
            zoomOffset: -1
        }).addTo(partnersmap);


        var markers = [] ;

        $.get('/wp-json/wp/v2/partner', function(response){
            if(response.length > 0){
                for (let i = 0; i < response.length; i++) {
                    const element = response[i];
                    if(element?.lat != '' && element?.lng != ''){
                        var marker = L.marker([element?.lat, element?.lng], {title:element.title.rendered,id:element.id}).addTo(partnersmap);
                        marker.bindPopup(element.title.rendered).openPopup();
                        markers.push(marker);
                        marker.on('click', onClick);
                    }
                    
                }
                var group = new L.featureGroup(markers);
                partnersmap.fitBounds(group.getBounds());
            }
        
        });

        function onClick(e) {
            var id = e.target.options.id ;
            $('.partners-list').find('li').removeClass('list-group-item-primary');
            $('.partners-list').find('[data-id="'+id+'"]').addClass('list-group-item-primary');
            $('.partners-list').find('[data-id="'+id+'"]').parents('.accordion-item').find('.accordion-button.collapsed').trigger('click');
        }

        $('.partners-list > li').on('click', function(){
            var id = $(this).data('id') ;
            var _marker = partnersmap.getMarkerById(id);
            _marker.fire('click');
        });
    }


    if($('#job_map').length > 0){
        let job_id = $('#job_map').attr("data-id") ;
        // Get marker by ID
        L.Map.include({
            getMarkerById: function (id) {
                var marker = null;
                this.eachLayer(function (layer) {
                    if (layer instanceof L.Marker) {
                        if (layer.options.id === id) {
                            marker = layer;
                        }
                    }
                });
                return marker;
            }
        });


        var jobmap = L.map('job_map', { dragging: !L.Browser.mobile, tap: !L.Browser.mobile }).setView([44.8947086,-0.2065675], 7);

        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZmxpc3RlZmxpc3RlIiwiYSI6ImNpeGt2bnliczAwMjIycW4wMmkwMzI3c2UifQ.fYceJb6F_mtjN3fmXz0wMQ', {
            maxZoom: 18,
            // attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, ' +
                // 'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            id: 'mapbox/streets-v11',
            tileSize: 512,
            zoomOffset: -1
        }).addTo(jobmap);


        var markers = [] ;

        $.get('/wp-json/wp/v2/job/'+job_id, function(response){
            if(response){
              
                    const element = response;
                    if(element?.lat != '' && element?.lng != '') {
                        var marker = L.marker([element?.lat, element?.lng], {title:element.title.rendered,id:element.id}).addTo(jobmap);
                        marker.bindPopup(element.title.rendered).openPopup();
                        markers.push(marker);
                        // marker.on('click', onClick);
                        jobmap.setView([element?.lat, element?.lng], 7);
                    }
                    
                // var group = new L.featureGroup(markers);
                // jobmap.fitBounds(group.getBounds());
            }
        
        });

        // function onClick(e) {
        //     var id = e.target.options.id ;
        //     $('.job-list').find('li').removeClass('list-group-item-primary');
        //     $('.job-list').find('[data-id="'+id+'"]').addClass('list-group-item-primary');
        //     $('.job-list').find('[data-id="'+id+'"]').parents('.accordion-item').find('.accordion-button.collapsed').trigger('click');
        // }

       
    }

    
   
});





